const app = document.getElementById('app') as HTMLElement | null
const game = document.getElementById('game') as HTMLElement | null
const capyBody = document.getElementById('capyBody') as HTMLElement | null
const capyWrap = document.getElementById('capyWrap') as HTMLElement | null
const tearField = document.getElementById('tearField') as HTMLElement | null

const body = document.getElementById('rigBody') as unknown as SVGGraphicsElement | null
const head = document.getElementById('rigHead') as unknown as SVGGraphicsElement | null
const torso = document.getElementById('rigTorso') as unknown as SVGGraphicsElement | null
const hips = document.getElementById('rigHips') as unknown as SVGGraphicsElement | null
const arms = document.getElementById('rigArms') as unknown as SVGGraphicsElement | null
const legs = document.getElementById('rigLegs') as unknown as SVGGraphicsElement | null
const armLeft = document.getElementById('armLeft') as unknown as SVGGraphicsElement | null
const armRight = document.getElementById('armRight') as unknown as SVGGraphicsElement | null

let liveEvent = 0
let lastPumping = false

function setTransform(el: SVGGraphicsElement | null, value: string) {
  if (el) el.style.transform = value
}

function readPressure() {
  if (!capyBody) return 0
  const sx = Number.parseFloat(capyBody.style.getPropertyValue('--sx') || '1')
  return Math.max(0, Math.min(1, (sx - 1) / .38))
}

function applyPressure(p: number) {
  if (!capyBody || document.body.classList.contains('simulation-mode')) return
  const smooth = p * p * (3 - 2 * p)
  const balloon = Math.pow(p, 1.12)
  setTransform(body, `scaleX(${1 + .41 * balloon}) scaleY(${1 + .12 * balloon}) translateY(${7 * smooth}px)`)
  setTransform(head, `translateY(${-7 * smooth}px) scaleX(${1 + .17 * balloon}) scaleY(${1 + .05 * balloon})`)
  setTransform(torso, `translateY(${4 * smooth}px) scaleX(${1 + .35 * balloon}) scaleY(${1 + .09 * balloon})`)
  setTransform(hips, `translateY(${7 * smooth}px) scaleX(${1 + .29 * balloon}) scaleY(${1 + .06 * balloon})`)
  setTransform(arms, `scaleX(${1 + .13 * balloon}) translateY(${4 * smooth}px)`)
  setTransform(legs, `scaleX(${1 + .16 * balloon}) translateY(${7 * smooth}px)`)
  setTransform(armLeft, `translate(${-18 * balloon}px,${2 * smooth}px) rotate(${-6 * smooth}deg)`)
  setTransform(armRight, `translate(${18 * balloon}px,${2 * smooth}px) rotate(${6 * smooth}deg)`)
  capyBody.style.setProperty('--eye-red', String(Math.max(0, Math.min(1, (p - .14) / .76))))

  if (app) {
    const level = p > .92 ? 16 : p > .82 ? 12 : p > .68 ? 9 : p > .52 ? 6 : p > .34 ? 3 : p > .17 ? 1 : 0
    for (let i = 1; i <= 20; i++) app.classList.toggle(`damage-${i}`, i <= level)
  }
}

function hash(n: number) {
  let x = n | 0
  x ^= x << 13
  x ^= x >>> 17
  x ^= x << 5
  return x >>> 0
}

function tearOnPump() {
  if (!tearField || !capyWrap) return
  liveEvent += 1
  const h = hash(liveEvent * 1103515245)
  const anchors = [[31,49],[42,52],[55,52],[67,49],[29,60],[41,63],[53,64],[66,61],[35,71],[49,73],[63,70]]
  const [bx, by] = anchors[liveEvent % anchors.length]!
  const p = readPressure()

  const hole = document.createElement('i')
  hole.className = 'rip-hole live-rip'
  hole.style.setProperty('--x', `${bx + ((h >>> 8) % 7) - 3}%`)
  hole.style.setProperty('--y', `${by + ((h >>> 11) % 7) - 3}%`)
  hole.style.setProperty('--rot', `${-35 + (h % 70)}deg`)
  hole.style.setProperty('--w', `${12 + (h % 13) + p * 14}px`)
  hole.style.setProperty('--h', `${8 + ((h >>> 5) % 8) + p * 9}px`)
  tearField.appendChild(hole)

  const fxLayer = document.querySelector<HTMLElement>('.live-fx-layer') || (() => {
    const el = document.createElement('div')
    el.className = 'sim-fx-layer live-fx-layer'
    capyWrap.appendChild(el)
    return el
  })()

  const kinds = ['cloth','thread','button','cloth','chain','cloth','spark']
  for (let i = 0; i < 3; i++) {
    const bit = document.createElement('i')
    const side = i === 1 ? -1 : 1
    bit.className = `rip-fx ${kinds[(liveEvent + i) % kinds.length]}`
    bit.style.setProperty('--x', `${bx + (i - 1) * 2}%`)
    bit.style.setProperty('--y', `${by + (i % 2) * 2}%`)
    bit.style.setProperty('--dx', `${side * (75 + ((h >>> (i + 2)) % 115))}px`)
    bit.style.setProperty('--dy', `${-(65 + ((h >>> (i + 5)) % 105))}px`)
    bit.style.setProperty('--r', `${side * (100 + ((h >>> (i + 8)) % 260))}deg`)
    bit.style.setProperty('--size', `${11 + ((h >>> (i + 12)) % 14)}px`)
    bit.style.setProperty('--life', `${.8 + p * .45}s`)
    bit.style.setProperty('--c', ['#18bff0','#ff2da6','#ffd52d','#6d37e8','#f28a21'][((liveEvent + i) % 5)]!)
    fxLayer.appendChild(bit)
    window.setTimeout(() => bit.remove(), 1500)
  }
}

if (capyBody) {
  const pressureObserver = new MutationObserver(() => applyPressure(readPressure()))
  pressureObserver.observe(capyBody, { attributes: true, attributeFilter: ['style'] })
  applyPressure(readPressure())
}

if (game) {
  const pumpObserver = new MutationObserver(() => {
    const pumping = game.classList.contains('pumping')
    if (pumping && !lastPumping && !document.body.classList.contains('simulation-mode')) tearOnPump()
    lastPumping = pumping
  })
  pumpObserver.observe(game, { attributes: true, attributeFilter: ['class'] })
}
